
<div class="dialog-container-main">

    <mat-dialog-content class="mat-typography">
      <div class="dialog-form-box">
        <div class="row">
          <div class="col m12 s12 counter-pos">
            <div>
            <mat-progress-spinner class="logout-timer" mode="determinate" [value]="progressBarValue">
            </mat-progress-spinner></div>
            <div><h2 class="time-left">{{timeLeft}}</h2></div>
            
          </div>
          <div class="col m12 s12">
            <mat-label class="labelsuper text-center margin-top2">Seconds left</mat-label>

          </div>
         <div class="col m12 s12">
          <h3 class="text-center font-stack margin-top3"> Session Expiring.</h3>
          </div>
          <div class="col m12 s12">

            <h5 class="text-center font-stack margin-bottom4">
              Session is about to expire due to inactivity. Please click continue to stay in the session.<br>
          </h5>

          </div>
        </div>

      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="btn-col-footer">
      <button
      mat-flat-button
      cdkFocusInitial
      class="green-btn btn-color continue-btn "
      (click)="close()"
      >
      Continue
      </button>

    </mat-dialog-actions>
    <div class="logout-session">
      <button
        class="logout-btn text-center"
        (click)="logout()">
        Logout Now
        </button>
    </div>


</div>
